import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=b0e96a6e&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"
import style0 from "./Region.vue?vue&type=style&index=0&id=b0e96a6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e96a6e",
  null
  
)

export default component.exports